export const COUNT_TEXT_DESCRIPTION = {
  title: "Скорость устного счета",
  description: "Насколько быстро и правильно вы считаете в уме? Тест на устный счет позволит проверить вашу память и скорость реакции",
  selectionTitle: "Ваш возраст",
  nameTitle: "Ваше имя",
  placeholder: "Введите ваше имя"
};

export const COUNT_TEXT_INSTRUCTION = {
  caption: "ИНСТРУКЦИЯ",
  descriptionList: [
    "Вам будут по очереди предлагаться цифры и арифметические действия с ними",
    "Посчитайте до конечного результата как можно быстрее и правильнее"
  ],
  warning: "Внимание! Запрещается использовать калькулятор",
  gameStartText: "НАЧАТЬ!",
};

export const DISPLAY_WINDOW = {
  INTRODUCTION: "introduction",
  GAME: "game",
  ANSWER: "answer",
  RESULT: "result"
};

const AGE_DATA = [
  {
    text: "7-10 лет",
    value: 0
  },
  {
    text: "10-14 лет",
    value: 1
  },
  {
    text: "14 и старше",
    value: 2,
  }
];

export const INITIAL_STATE = {
  stage: DISPLAY_WINDOW.INTRODUCTION,
  ageValue: 0,
  number: '',
  sign: '',
  fadeIn: false,
  name: '',
  answer: '',
};

export const GAME_OPTIONS = [
  [
    {
      delayTime: 1500,
      numbers: ['4', '2', '3', '1', '6', '1', '5', '7', '9', '8'],
      signs: ['', '+', '-', '-', '+', '+', '-', '+', '-', '+'],
      correctAnswer: 10,
    },
    {
      delayTime: 2000,
      numbers: ['23', '15', '11', '11', '13', '10', '22', '11', '13', '20'],
      signs: ['', '+', '-', '-', '+', '+', '-', '-', '+', '+'],
      correctAnswer: 39
    },
    {
      delayTime: 2000,
      numbers: ['16', '13', '10', '17', '60', '52', '20', '35', '54', '29'],
      signs: ['', '+', '+', '-', '+', '-', '-', '+', '+', '-'],
      correctAnswer: 70
    },
  ],
  [
    {
      delayTime: 2500,
      numbers: ['22', '83', '16', '42', '53', '29', '64', '44', '78', '36'],
      signs: ['', '+', '-', '+', '-', '-', '+', '+', '-', '-'],
      correctAnswer: 43,
    },
    {
      delayTime: 2500,
      numbers: ['54', '16', '37', '93', '74', '19', '22', '65', '35', '47'],
      signs: ['', '+', '-', '+', '+', '-', '-', '-', '-', '-'],
      correctAnswer: 12
    },
  ],
  [
    {
      delayTime: 3000,
      numbers: ['36', '44', '52', '64', '78', '36', '45', '46', '72', '85'],
      signs: ['', '+', '-', '+', '+', '-', '-', '-', '+', '+'],
      correctAnswer: 200,
    },
    {
      delayTime: 3000,
      numbers: ['94', '27', '44', '74', '18', '11', '74', '18', '44', '99'],
      signs: ['', '-', '+', '+', '-', '-', '+', '-', '+', '+'],
      correctAnswer: 355
    },
  ],
];

export const ANSWER_TEXT = {
  questionTitle: "Сколько получилось?",
  inputTitle: "Ваш ответ",
  placeholder: "Введите ответ",
  checkResultButtonText: "ПРОВЕРИТЬ"
}

export const RESULT_TEXT = {
  correctAnswerTitle: 'Верно! Молодец!',
  incorrectAnswerTitle: 'А вот и нет! Попробуй снова!',
  ageCategoryText: 'Возрастная категория',
  assumeTitle: 'Как решать в уме за секунды?',
  assumeDescription: 'Легко! Мы научим производить вычисления без калькулятора!',
  submitFreeLessonText: 'ЗАПИСАТЬСЯ НА БЕСПЛАТНЫЙ УРОК',
  shareResultText: "ПОДЕЛИТЬСЯ РЕЗУЛЬТАТОМ",
  tellFriendsText: "РАССКАЗАТЬ ДРУЗЬЯМ",
  restartTest: "ПРОЙТИ ТЕСТ ЗАНОВО",
  shareGoodTitleText: "Я считаю в уме за секунды!",
  shareDecentTitleText: "Умеешь решать задачки в уме за секунды?",
  shareGoodDescriptionText: "А ты умеешь? Пройди тест, давай посоревнуемся!",
  shareDecentDescriptionText: "Пройди тест, узнай на что ты способен!",
  noNameEntered: "Без имени"
};

export default AGE_DATA;
